import React from "react";
import AsyncSelect from "react-select/async";
import { components } from "react-select";
import styles from "./AsyncTagSelect.module.scss";

const CustomInput = (props) => (
  <div style={{ display: "flex", alignItems: "center", flex: 1, minWidth: "120px" }}>
    <components.Input {...props} />
    {props.selectProps.value?.length > 0 && !props.selectProps.inputValue && (
      <span className={styles.inlinePlaceholder}>{props.selectProps.placeholder}</span>
    )}
  </div>
);

const AsyncTagSelect = ({
  tags,
  onLoad,
  handleChange,
  placeholder = "Type to search...",
  inputId = "async-tag-select",
  noOptionMessage = "No results found",
  loadingMessage = "Searching...",
  classNamePrefix = "tag-select",
  isDisabled = false,
  ...rest
}) => {
  return (
    <AsyncSelect
      isMulti
      value={tags}
      loadOptions={onLoad}
      onChange={handleChange}
      placeholder={placeholder}
      inputId={inputId}
      isDisabled={isDisabled}
      components={{ Input: CustomInput }}
      noOptionsMessage={({ inputValue }) => (inputValue ? noOptionMessage : null)}
      loadingMessage={() => loadingMessage}
      defaultOptions={false}
      cacheOptions={false}
      isClearable={false}
      backspaceRemovesValue={false}
      classNamePrefix={classNamePrefix}
      {...rest}
    />
  );
};

export default AsyncTagSelect;
